import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import "./styles/app.css";

const rawBaseName = process.env.REACT_APP_BASENAME || process.env.PUBLIC_URL || "";
const routerBaseName = rawBaseName && rawBaseName !== "/" ? rawBaseName.replace(/\/+$/, "") : undefined;

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBaseName}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
